export default __webpack_public_path__ + "static/media/sensotrend_uploader_login.ec23e357.png";